
import {useStore} from "vuex";
import { defineComponent, reactive ,computed, ref} from "vue";
import MENU from "./menu.vue";

export default defineComponent({
    setup() {
        const store=useStore();
        // console.log(store)
        let state = reactive({
            sidebarMenu: computed(()=>store.getters.GET_MENU),
            currentMenu: computed(()=>store.getters.GET_CURRENTMENU),
            isSidebarNavCollapse: computed(()=>store.getters.getIsSidebarNavCollapse),
        });
        return {
            state,
        };
    },
    components: {
        MENU,
    },
});
